module.exports = __webpack_public_path__ + "img/title-1.114fa22a.png";